export const durationOptions = [
    { label: "1 Day", value: "1" },
    { label: "1 Week", value: "7" },
    { label: "1 Month", value: "30" },
    { label: "Custom Date", value: "till_date" },
    { label: "Permanent", value: "1000" },
];